export const DEFAULT_COOKIES_SETTINGS = "performance=1,marketing=1,advertisement=0"

const parseCookie = (cookie: string = DEFAULT_COOKIES_SETTINGS) => ({
  performance: cookie.includes("performance=1"),
  marketing: cookie.includes("marketing=1"),
  advertisement: cookie.includes("advertisement=1"),
})

export default parseCookie
